import { getFormulaKeyForHandle } from "@/lib/ingredientBenefits";
import { RESEARCH } from "@/lib/research";

/** Dose and ingredient evidence are separate from absorption comparisons. */
export function OvaVitaminD3Evidence({ handle }: { handle: string }) {
  if (getFormulaKeyForHandle(handle) !== "ova") return null;
  const research = RESEARCH.find((entry) => entry.slug === "vitamin-d3");
  if (!research) return null;

  return (
    <section className="mt-6 rounded-xl border border-border p-5" aria-labelledby="ova-d3-evidence-title">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">Ingredient evidence</p>
      <h3 id="ova-d3-evidence-title" className="mt-2 text-xl font-semibold">
        Vitamin D3 · 600 IU (15 mcg) per sachet
      </h3>
      <p className="mt-3 text-sm leading-relaxed">{research.summary}</p>
      <a className="mt-3 inline-block text-sm underline" href="/ingredients/vitamin-d3">
        Explore vitamin D3 and its references
      </a>
      <ul className="mt-3 space-y-2 text-sm">
        {research.citations.map((citation) => (
          <li key={citation.url}>
            <a href={citation.url} target="_blank" rel="noopener noreferrer" className="underline">
              {citation.title} · {citation.journal}, {citation.year}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
